document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".product_atc").forEach(button => {
    button.addEventListener("click", () => {
      const productId = button.dataset.productId;
      const modal = document.getElementById(`modal-${productId}`);
      if (!modal) return;

      modal.classList.remove("hidden");

      const content = modal.querySelector(".modal-content");
      if (content) {
        content.classList.remove("animate");
        void content.offsetWidth;
        content.classList.add("animate");
      }

      modal.addEventListener("click", (e) => {
        if (e.target === modal) modal.classList.add("hidden");
      });
    });
  });

  document.querySelectorAll(".close-modal").forEach(btn => {
    btn.addEventListener("click", () => {
      const modal = btn.closest(".product-modal");
      if (modal) modal.classList.add("hidden");
    });
  });

  document.querySelectorAll(".collection-modal-form").forEach(form => {
    const isB2B = window.IS_B2B === true || form?.dataset?.b2b === "true";
    const productId = form.dataset.productId;
    const handle = form.dataset.productHandle;
    const quantityEl = form.querySelector(`#quantity-${productId}`);

    let quantity = 1;
    let productJSON = null;
    let currentVariant = null;

    const formatMoney = (cents) => {
      if (cents == null || Number.isNaN(Number(cents))) return "";
      return `£${(Number(cents) / 100).toFixed(2)}`;
    };

    const getWidget = () => {
      return (
        form.querySelector("[data-subscription-widget]") ||
        form.querySelector(".custom-recharge-widget__wrapper") ||
        form.querySelector(".recharge-widget__container")
      );
    };

    const getPurchaseRadios = () => {
      return form.querySelectorAll(
        '.purchase-option, .rc-radio__input[value="subsave"], .rc-radio__input[value="onetime"]'
      );
    };

    const getSubscriptionRadio = () => {
      return form.querySelector(
        '.purchase-option[value="subscription"], .rc-radio__input[value="subsave"]'
      );
    };

    const getOnetimeRadio = () => {
      return form.querySelector(
        '.purchase-option[value="onetime"], .rc-radio__input[value="onetime"]'
      );
    };

    const getPlanSelect = () => {
      return (
        form.querySelector(".selling-plan-selector") ||
        form.querySelector('select[name="selling_plan"]') ||
        form.querySelector("#selling_plan")
      );
    };

    const getPurchaseType = () => {
      const checked = Array.from(getPurchaseRadios()).find(radio => radio.checked);
      if (!checked) return "onetime";

      if (checked.value === "subsave" || checked.value === "subscription") {
        return "subscription";
      }

      return "onetime";
    };

    const getSelectedOptions = () => {
      const options = [];

      form.querySelectorAll(".variant-option").forEach(input => {
        if (input.checked) {
          options[parseInt(input.dataset.optionPosition, 10)] = input.value;
        }
      });

      return options;
    };

    const findVariantFromOptions = () => {
      if (!productJSON?.variants?.length) return null;

      const variantInputs = form.querySelectorAll(".variant-option");

      if (!variantInputs.length) {
        return (
          productJSON.variants.find(variant => variant.available) ||
          productJSON.variants[0]
        );
      }

      const options = getSelectedOptions();

      return productJSON.variants.find(variant => {
        return options.every((option, index) => option === variant.options[index]);
      });
    };

    const findPlanById = (planId) => {
      for (const group of productJSON?.selling_plan_groups || []) {
        const plan = group.selling_plans.find(sp => Number(sp.id) === Number(planId));
        if (plan) return plan;
      }

      return null;
    };

    const computeAdjustedPrice = (basePriceCents, allocation, plan) => {
      if (allocation?.price != null) return allocation.price;

      const adjustment =
        allocation?.price_adjustments?.[0] ||
        plan?.price_adjustments?.[0];

      if (!adjustment) return null;

      if (adjustment.price != null) return adjustment.price;

      if (adjustment.value_type === "percentage") {
        return Math.round(basePriceCents * (100 - adjustment.value) / 100);
      }

      if (adjustment.value_type === "fixed_amount") {
        return Math.max(0, basePriceCents - adjustment.value);
      }

      return null;
    };

    const getSelectedSellingPlanData = (variant) => {
      const purchaseType = getPurchaseType();
      const planSelect = getPlanSelect();

      if (purchaseType !== "subscription") {
        return {
          sellingPlanId: null,
          allocation: null,
          plan: null,
          adjustedPrice: null,
          discountPercent: null
        };
      }

      const allocations = variant?.selling_plan_allocations || [];
      if (!allocations.length) {
        return {
          sellingPlanId: null,
          allocation: null,
          plan: null,
          adjustedPrice: null,
          discountPercent: null
        };
      }

      let selectedPlanId = planSelect?.value ? Number(planSelect.value) : null;
      let allocation = selectedPlanId
        ? allocations.find(a => Number(a.selling_plan_id) === selectedPlanId)
        : null;

      if (!allocation) allocation = allocations[0];

      selectedPlanId = allocation?.selling_plan_id || null;

      const plan = selectedPlanId ? findPlanById(selectedPlanId) : null;
      const adjustedPrice = allocation
        ? computeAdjustedPrice(variant.price, allocation, plan)
        : null;

      const discountPercent =
        adjustedPrice != null && variant.price > adjustedPrice
          ? Math.round(((variant.price - adjustedPrice) / variant.price) * 100)
          : null;

      return {
        sellingPlanId: selectedPlanId,
        allocation,
        plan,
        adjustedPrice,
        discountPercent
      };
    };


      const getSubscriptionDiscountData = (variant) => {
      const allocations = variant?.selling_plan_allocations || [];

      if (!allocations.length) {
        return {
          adjustedPrice: null,
          discountPercent: null
        };
      }

      const planSelect = getPlanSelect();
      let selectedPlanId = planSelect?.value ? Number(planSelect.value) : null;

      let allocation = selectedPlanId
        ? allocations.find(a => Number(a.selling_plan_id) === selectedPlanId)
        : null;

      if (!allocation) allocation = allocations[0];

      const plan = allocation?.selling_plan_id
        ? findPlanById(allocation.selling_plan_id)
        : null;

      const adjustedPrice = allocation
        ? computeAdjustedPrice(variant.price, allocation, plan)
        : null;

      const discountPercent =
        adjustedPrice != null && variant.price > adjustedPrice
          ? Math.round(((variant.price - adjustedPrice) / variant.price) * 100)
          : null;

      return {
        adjustedPrice,
        discountPercent
      };
    };
    const rebuildPlanSelect = (variant) => {
      const select = getPlanSelect();
      if (!select) return;

      select.innerHTML = "";

      const allocations = variant?.selling_plan_allocations || [];

      allocations.forEach(allocation => {
        const plan = findPlanById(allocation.selling_plan_id);
        const adjustedPrice = computeAdjustedPrice(variant.price, allocation, plan);

        const option = document.createElement("option");
        option.value = allocation.selling_plan_id;
        option.textContent = plan?.name || "";
        option.dataset.adjustedPrice = adjustedPrice != null ? adjustedPrice : "";
        option.dataset.discountPercent =
          adjustedPrice != null && variant.price > adjustedPrice
            ? Math.round(((variant.price - adjustedPrice) / variant.price) * 100)
            : "";

        select.appendChild(option);
      });

      if (select.options.length) {
        select.disabled = false;
        select.classList.remove("hidden");
      } else {
        select.disabled = true;
        select.classList.add("hidden");
      }
    };

    const removeAlpineCloak = () => {
      form.querySelectorAll("[x-cloak]").forEach(el => {
        el.removeAttribute("x-cloak");
      });
    };

    const setWidgetVisibility = (variant) => {
      const widget = getWidget();
      if (!widget) return;

      const hasSellingPlan =
        Array.isArray(variant?.selling_plan_allocations) &&
        variant.selling_plan_allocations.length > 0;

      const shouldHideWidget = isB2B || !hasSellingPlan;

      if (shouldHideWidget) {
        widget.style.setProperty("display", "none", "important");
        widget.classList.add("hidden");

        const oneTimeRadio = getOnetimeRadio();
        if (oneTimeRadio) oneTimeRadio.checked = true;
      } else {
        widget.style.removeProperty("display");
        widget.classList.remove("hidden");

        const subscriptionRadio = getSubscriptionRadio();
        if (subscriptionRadio && !isB2B) subscriptionRadio.checked = true;
      }
    };

    const updateWidgetState = () => {
      const widget = getWidget();
      if (!widget) return;

      removeAlpineCloak();

      const purchaseType = getPurchaseType();
      const isSubscription = purchaseType === "subscription";

      const subscriptionRadio = getSubscriptionRadio();
      const onetimeRadio = getOnetimeRadio();

      const subscriptionCard =
        subscriptionRadio?.closest(".rounded.border") ||
        subscriptionRadio?.closest(".subscription-option");

      const onetimeCard =
        onetimeRadio?.closest(".rounded-md.border") ||
        onetimeRadio?.closest(".onetime-option");

      const subscriptionHeader = subscriptionRadio?.closest(".flex.items-center");

      const subscriptionDetails = Array.from(widget.querySelectorAll("[x-show]")).filter(el => {
        return el.getAttribute("x-show")?.includes("subsave");
      });

      const onetimeDetails = Array.from(widget.querySelectorAll("[x-show]")).filter(el => {
        return el.getAttribute("x-show")?.includes("onetime");
      });

      if (subscriptionCard) {
        subscriptionCard.classList.toggle("bg-base-pale-white", isSubscription);
      }

      if (subscriptionHeader) {
        subscriptionHeader.classList.toggle("bg-base-black", isSubscription);
        subscriptionHeader.classList.toggle("text-white", isSubscription);
        subscriptionHeader.classList.toggle("mb-0", isSubscription);
      }

      if (onetimeCard) {
        onetimeCard.classList.toggle("bg-base-black", !isSubscription);
      }

      subscriptionDetails.forEach(el => {
        el.style.display = isSubscription ? "" : "none";
      });

      onetimeDetails.forEach(el => {
        el.style.display = !isSubscription ? "" : "none";
      });

      widget.querySelectorAll(".subs_freq").forEach(el => {
        el.classList.toggle("hidden", !isSubscription);
      });
      
      widget.querySelectorAll(".subs_perks_one").forEach(el => {
        el.classList.toggle("hidden", isSubscription);
      });
      
      widget.querySelectorAll(".subscription_perks_new").forEach(el => {
        el.classList.toggle("hidden", !isSubscription);
      });

      widget.querySelectorAll(".subs_perks").forEach(el => {
        el.classList.toggle("hidden", !isSubscription);
      });

      const mostPopular = widget.querySelector(".most-popular-tag");
      if (mostPopular) {
        mostPopular.style.display = isSubscription ? "none" : "";
      }

      const subscriptionTitle = widget.querySelector(".featured-subscription-title");
      const saveBadge = widget.querySelector(".sellingPlan_discount");
      const subscriptionPrice = widget.querySelector(".discounted-price");
      const onetimeTitle = widget.querySelector(".featured-onetime-title");
      const onetimePrice = widget.querySelector(".one-time-price");

      if (subscriptionTitle) {
        subscriptionTitle.classList.toggle("text-white", isSubscription);
        subscriptionTitle.classList.toggle("text-mono-gray", !isSubscription);
      }

      if (subscriptionPrice) {
        subscriptionPrice.classList.toggle("text-white", isSubscription);
        subscriptionPrice.classList.toggle("text-mono-gray", !isSubscription);
      }

      if (onetimeTitle) {
        onetimeTitle.classList.toggle("text-white", !isSubscription);
        onetimeTitle.classList.toggle("text-mono-gray", isSubscription);
      }

      if (onetimePrice) {
        onetimePrice.classList.toggle("text-white", !isSubscription);
        onetimePrice.classList.toggle("text-mono-gray", isSubscription);
      }

      if (saveBadge) {
        saveBadge.style.display = "";
        saveBadge.classList.toggle("bg-base-white", isSubscription);
        saveBadge.classList.toggle("bg-base-yellow", !isSubscription);
      }
      widget.querySelectorAll("[data-radio-type='selling_plan']").forEach(input => {
        input.checked = isSubscription;
      });
    };

    const updateVariantBadge = (variant) => {
      const container =
        form.closest("[data-featured-product]") ||
        form.closest('[id^="main-product-"]') ||
        form;

      const badgeScript = form.querySelector("[data-featured-variant-badges]");
      if (!badgeScript) return;

      let badgeData = null;

      try {
        badgeData = JSON.parse(badgeScript.textContent);
      } catch (error) {
        return;
      }

      const badgeText = badgeData?.variantBadges?.[variant.id] || "";

      container.querySelectorAll(".variant-value").forEach(el => {
        el.textContent = badgeText || "";
        el.style.display = badgeText ? "" : "none";
      });
    };

    const updatePrices = (variant) => {
      if (!variant) return;

      currentVariant = variant;

      const featuredRoot =
      form.closest("[data-featured-product]") ||
      form.closest('[id^="main-product-"]') ||
      form;

    featuredRoot.dataset.selectedVariantId = variant.id;

    document.dispatchEvent(new CustomEvent("featured-product:variant-change", {
      detail: {
        root: featuredRoot,
        variantId: variant.id
      }
    }));

      const sellingPlanData = getSelectedSellingPlanData(variant);
      const displayPrice =
        sellingPlanData.adjustedPrice != null
          ? sellingPlanData.adjustedPrice
          : variant.price;

      const container =
        form.closest("[data-featured-product]") ||
        form.closest('[id^="main-product-"]') ||
        form;

      container.querySelectorAll(".selected-price").forEach(el => {
        el.textContent = formatMoney(displayPrice);
      });

      const purchaseType = getPurchaseType();

      let compareAtCents = null;

      // Subscription active:
      // show one-time price as strikethrough, then subscription price
      if (
        purchaseType === "subscription" &&
        sellingPlanData.adjustedPrice != null &&
        sellingPlanData.adjustedPrice < variant.price
      ) {
        compareAtCents = variant.price;
      }

      // One-time active:
      // show compare_at_price as strikethrough, then one-time price
      if (
        purchaseType === "onetime" &&
        Number.isFinite(variant.compare_at_price) &&
        variant.compare_at_price > variant.price
      ) {
        compareAtCents = variant.compare_at_price;
      }

      container.querySelectorAll("[data-compare]").forEach(el => {
        if (compareAtCents) {
          el.textContent = formatMoney(compareAtCents);
          el.style.display = "";
        } else {
          el.textContent = "";
          el.style.display = "none";
        }
      });

      form.querySelectorAll(".original-price").forEach(el => {
        el.textContent = formatMoney(variant.price);
      });

        const subscriptionDiscountData = getSubscriptionDiscountData(variant);

        form.querySelectorAll(".discounted-price").forEach(el => {
          el.textContent =
            subscriptionDiscountData.adjustedPrice != null
              ? formatMoney(subscriptionDiscountData.adjustedPrice)
              : "";
        });

        form.querySelectorAll(".sellingPlan_discount").forEach(el => {
          el.textContent = subscriptionDiscountData.discountPercent
            ? `SAVE ${subscriptionDiscountData.discountPercent}%`
            : "";

          el.style.display = subscriptionDiscountData.discountPercent ? "" : "none";
        });
      form.querySelectorAll(".subscription_price").forEach(el => {
        const isInsideOnetime =
          el.closest("#oneTimePurchase") ||
          el.closest('[for^="oneTimePurchase"]') ||
          el.closest(".onetime-option") ||
          el.closest(".featured-onetime-card");

        if (isInsideOnetime) {
          el.textContent = formatMoney(variant.price);
        } else {
          el.textContent = formatMoney(displayPrice);
        }
      });

      const atcBtn = form.querySelector(".add-to-cart-btn");
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.classList.toggle("disabled", !variant.available);

        const buttonLabel = atcBtn.childNodes[0];
        if (buttonLabel && buttonLabel.nodeType === Node.TEXT_NODE) {
          buttonLabel.textContent = variant.available ? "Add to cart - " : "Sold out";
        }
      }

      updateVariantBadge(variant);
      updateWidgetState();
    };

    const updateSelectedOptionClasses = (changedInput) => {
      if (!changedInput) return;

      const groupInputs = form.querySelectorAll(`input[name="${changedInput.name}"]`);

      groupInputs.forEach(input => {
        const parent = input.closest("li") || input.parentElement;
        parent?.classList.remove("selected");
      });

      const selectedParent = changedInput.closest("li") || changedInput.parentElement;
      selectedParent?.classList.add("selected");
    };

    const updateVariant = () => {
      const variant = findVariantFromOptions();
      if (!variant) return;

      currentVariant = variant;

      setWidgetVisibility(variant);
      rebuildPlanSelect(variant);
      updatePrices(variant);
    };
    
      const setupInvalidVariantFiltering = () => {
        if (!productJSON?.variants?.length) return;

        const fieldsets = Array.from(form.querySelectorAll("fieldset"));
        const optionRadios = Array.from(form.querySelectorAll(".variant-option"));

        if (!fieldsets.length || !optionRadios.length) return;

        const optionGroups = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll(".variant-option"));
        });

        const getCheckedOptions = () => {
          return optionGroups.map((group) => {
            const checked = group.find((input) => input.checked);
            return checked ? checked.value : null;
          });
        };

        const showOption = (input) => {
          const item = input.closest("li") || input.parentElement;
          if (!item) return;

          item.style.display = "";
          item.classList.add("active-option");
        };

        const hideOption = (input) => {
          const item = input.closest("li") || input.parentElement;
          if (!item) return;

          item.style.display = "none";
          item.classList.remove("active-option");
        };

        const isVisible = (input) => {
          const item = input.closest("li") || input.parentElement;
          return item && item.style.display !== "none";
        };

        const ensureVisibleCheckedOption = () => {
          optionGroups.forEach((group) => {
            const checkedVisible = group.find((input) => input.checked && isVisible(input));

            if (checkedVisible) return;

            const firstVisible = group.find((input) => isVisible(input));

            group.forEach((input) => {
              input.checked = false;
              const item = input.closest("li") || input.parentElement;
              item?.classList.remove("selected");
            });

            if (firstVisible) {
              firstVisible.checked = true;

              const item = firstVisible.closest("li") || firstVisible.parentElement;
              item?.classList.add("selected");

              firstVisible.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });
        };

        const updateVisibleOptions = () => {
          const selectedOptions = getCheckedOptions();

          optionRadios.forEach((input) => {
            hideOption(input);
          });

          productJSON.variants.forEach((variant) => {
            if (!Array.isArray(variant.options)) return;

            // Option 1 is always shown if it exists in any variant
            if (optionGroups[0]) {
              optionGroups[0].forEach((input) => {
                if (variant.options[0] === input.value) {
                  showOption(input);
                }
              });
            }

            // Option 2 only shows when option 1 matches
            if (optionGroups[1] && selectedOptions[0] === variant.options[0]) {
              optionGroups[1].forEach((input) => {
                if (variant.options[1] === input.value) {
                  showOption(input);
                }
              });
            }

            // Option 3 only shows when option 1 + option 2 match
            if (
              optionGroups[2] &&
              selectedOptions[0] === variant.options[0] &&
              selectedOptions[1] === variant.options[1]
            ) {
              optionGroups[2].forEach((input) => {
                if (variant.options[2] === input.value) {
                  showOption(input);
                }
              });
            }
          });

          ensureVisibleCheckedOption();
        };

        form.querySelectorAll(".variant-option").forEach((input) => {
          input.addEventListener("change", () => {
            updateVisibleOptions();
          });
        });

        updateVisibleOptions();
      };

    const addToCart = async () => {
      const variant = currentVariant || findVariantFromOptions();

      if (!variant) {
        alert("Variant not found");
        return;
      }

      if (!variant.available) {
        alert("This variant is currently out of stock");
        return;
      }

      const sellingPlanData = getSelectedSellingPlanData(variant);

      const payload = {
        items: [
          {
            id: variant.id,
            quantity,
            ...(sellingPlanData.sellingPlanId
              ? { selling_plan: sellingPlanData.sellingPlanId }
              : {})
          }
        ]
      };

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error("Add to cart failed");
        }

        document.dispatchEvent(new CustomEvent("cart:render"));
        document.dispatchEvent(new CustomEvent("cart:open"));

        const modal = document.getElementById(`modal-${productId}`);
        if (modal) modal.classList.add("hidden");
      } catch (error) {
        console.error("Add to cart error", error);
      }
    };

    const setupListeners = () => {
      form.querySelectorAll(".variant-option").forEach(input => {
        input.addEventListener("change", () => {
          updateSelectedOptionClasses(input);
          updateVariant();
        });
      });

      getPurchaseRadios().forEach(radio => {
        radio.addEventListener("change", () => {
          updateWidgetState();
          updatePrices(currentVariant || findVariantFromOptions());
        });
      });

      const planSelect = getPlanSelect();
      if (planSelect) {
        planSelect.addEventListener("change", () => {
          updatePrices(currentVariant || findVariantFromOptions());
        });
      }

      const incBtn = form.querySelector(".increase-qty");
      const decBtn = form.querySelector(".decrease-qty");

      if (incBtn) {
        incBtn.addEventListener("click", () => {
          quantity++;
          if (quantityEl) quantityEl.textContent = quantity;
          updatePrices(currentVariant || findVariantFromOptions());
        });
      }

      if (decBtn) {
        decBtn.addEventListener("click", () => {
          if (quantity > 1) quantity--;
          if (quantityEl) quantityEl.textContent = quantity;
          updatePrices(currentVariant || findVariantFromOptions());
        });
      }

      const atcBtn = form.querySelector(".add-to-cart-btn");
      if (atcBtn) {
        atcBtn.addEventListener("click", addToCart);
      }
    };

    fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(data => {
        productJSON = data;

        removeAlpineCloak();
        setupListeners();
        setupInvalidVariantFiltering();

        const defaultVariant =
          findVariantFromOptions() ||
          productJSON.variants.find(variant => variant.available) ||
          productJSON.variants[0];

        if (defaultVariant) {
          currentVariant = defaultVariant;
          setWidgetVisibility(defaultVariant);
          rebuildPlanSelect(defaultVariant);
          updatePrices(defaultVariant);
        }
      })
      .catch(error => {
        console.error("Featured product fetch error", error);
      });
  });
});